import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobileMenu", "openButton", "closeButton"]

  connect() {
    this.closeMobileMenu()
  }

  openMobileMenu() {
    this.mobileMenuTarget.style.display = "block"
    document.body.style.overflow = "hidden"
    this.openButtonTarget.style.display = "none"
    this.closeButtonTarget.style.display = "block"
  }

  closeMobileMenu() {
    this.mobileMenuTarget.style.display = "none"
    document.body.style.overflow = "auto"
    this.openButtonTarget.style.display = "block"
    this.closeButtonTarget.style.display = "none"
  }
}
